<template>
  <span>
    <b-button icon-left="copy" size="is-small-1" type="is-custom-gray" @click.prevent="copy">{{ $t('admin.order.copyLinkChangePayment') }}</b-button>
    <input v-if="showInput" ref="input" v-model="input">
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      default: process.env.lang
    }
  },
  data () {
    return {
      input: '',
      showInput: false
    }
  },
  methods: {
    copy () {
      this.input = this._frontBaseUrl + this.localePath({ name: 'profile-orders-id', params: { id: this.id }, query: { accessToken: this.token } }, this.lang)
      this.showInput = true
      this.$nextTick(() => {
        const textToCopy = this.$refs.input
        textToCopy.select()
        document.execCommand('copy')
        document.getSelection().empty()
        this.$buefy.toast.open({
          message: this.$t('actions.copied'),
          type: 'is-success'
        })
        this.showInput = false
      })
    }
  }
}
</script>
